import { ApiNotification } from '@repo/types';

const notificationTypeTable: Record<string, string> = {
  'review-created': '/reviewing/:id',
  'review-submitted': '/authoring/:id/reviews',
  'reviewer-added': '/review-invitation/:id?email=:meta_email',
  'invitation-accepted': '/manage-people',
  'affiliation-created': '/manage-people',
  'reviewer-invitation-declined': '/authoring/:id/reviews',
  'reviewer-invitation-expired': '/authoring/:id/reviews',
  'review-expired': '/authoring/:id/reviews',
  'all-reviews-approved': '/authoring/:id/proofing',
  'manuscript-ready-for-publication': '/authoring/:id/publish',
  'doi-required': '/admin-settings',
};

export function useNotificationLink() {
  const getNotificationLink = (notication: ApiNotification) => {
    const type = notication.type;
    let path = notificationTypeTable[type];
    if (!path) {
      return null;
    }
    const meta = notication.metadata;
    if (meta) {
      for (const key in meta) {
        const value = meta[key] || '';
        path = path.replace(
          new RegExp(`:meta_${key}`, 'g'),
          encodeURIComponent(value)
        );
      }
    }
    return path.replace(/:id/, notication.targetId);
  };
  return { getNotificationLink };
}
